import React, { useState } from "react";
import { Input, DateInput } from "../..";
import locales from "../../../constants";

const FirstStep = ({
  register,
  errors,
  step,
  setStep,
  triggerValidation,
  formState,
  lang,
}) => {
  const translation = locales[lang];
  const [isValidating, setValidating] = useState(false);
  const checkErrors = (data) => {
    setTimeout(() => {
      data[Object.keys(data)[0]].ref.focus();
      setValidating(false);
    }, 200);
  };
  isValidating && checkErrors(errors);
  return (
    <div
      className="step_1 stepWrapper"
      style={{ display: step === 1 ? "block" : "none" }}
    >
      <p className="desc">{translation.brief_shop.step_1_desc}</p>
      <div className="row justify-content-md-center">
        <div className="col-md-8">
          <h4>{translation.brief_shop.step_1_subheader}</h4>
          <div className="row">
            <div className="col-sm-6">
              <Input
                type="text"
                name="company_name"
                label={translation.brief_shop.step_1_company_name}
                register={register}
                validation={{
                  required: translation.brief_shop.input_required,
                }}
                errors={errors}
              />
            </div>
            <div className="col-sm-6">
              <Input
                type="email"
                name="email"
                label="E-mail"
                register={register}
                validation={{
                  required: translation.brief_shop.input_required,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
                    message: translation.brief_shop.input_email_error,
                  },
                }}
                errors={errors}
              />
            </div>
            <div className="col-sm-6">
              <Input
                type="text"
                name="client_name"
                label={translation.brief_shop.step_1_client_name}
                register={register}
                validation={{
                  required: translation.brief_shop.input_required,
                }}
                errors={errors}
              />
            </div>
            <div className="col-sm-6">
              <Input
                type="tel"
                name="phone"
                label={translation.brief_shop.step_1_phone}
                register={register}
              />
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <h4>{translation.brief_shop.step_1_duration_project}</h4>
          <div className="row">
            <div className="col-sm-6">
              <DateInput
                name="date_start"
                label={translation.brief_shop.step_1_data_start}
                validation={{
                  required: translation.brief_shop.input_required,
                }}
                register={register}
                errors={errors}
                lang={lang}
              />
            </div>
            <div className="col-sm-6">
              <DateInput
                name="date_end"
                label={translation.brief_shop.step_1_data_stop}
                validation={{
                  required: translation.brief_shop.input_required,
                }}
                register={register}
                errors={errors}
                lang={lang}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 text-right">
          <button
            className="btn_brief"
            type="button"
            onClick={async () => {
              const isValid = await triggerValidation([
                { name: "company_name" },
                { name: "email" },
                { name: "client_name" },
                { name: "date_start" },
                { name: "date_end" },
              ]);

              isValid ? setStep(2) : setValidating(true);
            }}
          >
            {translation.brief_shop.step_1_next_step}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstStep;
